  <div class="myPurchase-dialog-container" [hidden]="dataSource.data.length == 0"
    *ngIf="permissionData$| async as permissionData">
    <div class="myPurchase-dialog-header">Capital usage requirements</div>
    <!-- <div class="mat-table-wrapper"> -->
      <div class="myPurchase-dialog-content">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 data-grid-table">
      <ng-container *ngFor="let column of columns; let i = index">
        <!-- first column -->
        <ng-container [matColumnDef]="column.columnDef" *ngIf="(column.columnDef !== 'ItemDescription' && column.columnDef !== 'Reasons' ) ">
          <th mat-header-cell *matHeaderCellDef>
            {{ column.header }}
          </th>
          <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }">
            {{ column.cell(row) }}
          </td>
        </ng-container>
 
        <ng-container [matColumnDef]="column.columnDef" *ngIf="column.columnDef === 'ItemDescription'">
          <th mat-header-cell *matHeaderCellDef>
            {{ column.header }}
          </th>
          <td mat-cell *matCellDef="let row"  [tp]="row['ItemDescription']" tpClassName="custom-tooltip" tpMaxWidth="300px" tpAppendTo="parent"  tpPlacement="auto">
            {{ row['ItemDescription']}}
          </td>
        </ng-container>
 
 
        <ng-container [matColumnDef]="column.columnDef" *ngIf="column.columnDef === 'Reasons'">
          <th mat-header-cell *matHeaderCellDef>
            {{ column.header }}
          </th>
          <td mat-cell *matCellDef="let row"  [tp]="row['reasonDescription']" tpClassName="custom-tooltip" tpMaxWidth="300px"  tpAppendTo="parent"  tpPlacement="auto">
            {{ row['reasonDescription']}}
          </td>
        </ng-container>
 
    </ng-container>
 
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (mouseenter)="row.hovered = true"
        (mouseleave)="row.hovered = false"></tr>
    </table>
 
  </div>
    <div class="myPurchase-usage-dialog-actions">
      <mat-paginator #itemPg [length]="dataSource.data.length" [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons></mat-paginator>
    <mat-dialog-actions>
      <button mat-raised-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
  </div>
 